<script lang="ts">
	import { onMount } from 'svelte';
	import SvelteSeo from 'svelte-seo';
	import { page } from '$app/state';

	interface Props {
		facebookAppId?: string | undefined;
		getImageUrl: (path: string | null | undefined) => string;
	}

	let { facebookAppId = undefined, getImageUrl }: Props = $props();

	let seo = $derived(page.data.seo);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const SvelteSeoComponent = SvelteSeo as any;
	let image = $derived(getImageUrl(seo?.image?.filename_disk) as string);

	let openGraph = $derived({
		title: seo?.title,
		description: seo?.description,
		image,
		images: [
			{
				url: image,
				width: seo?.image?.width,
				height: seo?.image?.height,
				alt: seo?.title
			}
		],
		url: seo?.url,
		type: seo?.ogType ?? 'website',
		site_name: seo?.site
	});

	onMount(() => {
		if (document.querySelectorAll('link[rel="canonical"]').length > 1) {
			// Deletes the duplicated GTAG scripts
			const gtagElt = document.querySelectorAll(
				"[src='https://www.googletagmanager.com/gtag/js?id=G-X6VGHGQMK1']"
			)[0];

			if (gtagElt) {
				gtagElt.remove();
			}

			const gtagScriptElt = document.getElementsByClassName('gtag-script')[0];

			if (gtagScriptElt) {
				gtagScriptElt.remove();
			}

			const gtmScriptElt = document.getElementsByClassName('gtm-script')[0];

			if (gtmScriptElt) {
				gtagScriptElt.remove();
			}

			// Deletes the duplicated seo tags
			document.querySelectorAll('link[rel="canonical"]')[0].remove();
			document.querySelectorAll('meta[name="description"]')[0].remove();
			document.querySelectorAll('meta[name="keywords"]')[0]?.remove?.();
			document.querySelectorAll('meta[name="twitter:site"]')[0].remove();
			document.querySelectorAll('meta[name="twitter:title"]')[0].remove();
			document.querySelectorAll('meta[name="twitter:description"]')[0].remove();
			document.querySelectorAll('meta[name="twitter:image"]')[0].remove();
			document.querySelectorAll('meta[name="twitter:card"]')[0].remove();
			document.querySelectorAll('meta[property="og:url"]')[0].remove();
			document.querySelectorAll('meta[property="og:type"]')[0].remove();
			document.querySelectorAll('meta[property="og:site_name"]')[0].remove();
			document.querySelectorAll('meta[property="og:title"]')[0].remove();
			document.querySelectorAll('meta[property="og:image"]')[0].remove();
			document.querySelectorAll('meta[property="og:image:url"]')[0].remove();
			document.querySelectorAll('meta[property="og:image:width"]')[0].remove();
			document.querySelectorAll('meta[property="og:image:height"]')[0].remove();
			document.querySelectorAll('meta[property="og:image:alt"]')[0].remove();
			document.querySelectorAll('meta[property="og:description"]')[0].remove();
		}
	});
</script>

<svelte:head>
	<!-- SvelteSeo always emits its own robots tag, so this is only for pages it
	     doesn't render (no SEO image). -->
	{#if seo?.noIndex && !(seo && image)}
		<meta name="robots" content="noindex,nofollow" />
	{/if}
	<title>{seo?.title}</title>
</svelte:head>

{#if seo && image}
	<SvelteSeoComponent
		title={seo.title}
		description={seo.description}
		canonical={seo.url}
		keywords={seo.keywords}
		noindex={!!seo.noIndex}
		nofollow={!!seo.noIndex}
		{openGraph}
		twitter={{
			card: 'summary_large_image',
			site: '@heni',
			title: seo.title,
			description: seo.description,
			image
		}}
		facebook={facebookAppId
			? {
					appId: facebookAppId
				}
			: undefined}
	/>
{/if}
